export const PROFILE = 'Мой профиль';
export const LIST = 'Список бланков';
export const ANALYTICS = 'Аналитика';
export const ADMIN = 'Админ-панель';
export const EXIST_QUESTION = 'Вы действительно хотите выйти?';
export const STAY = 'Остаться';
export const OUT = 'Да, выйти';
export const ADMIN_MODE = 'Вы находитесь в режиме администратора';
export const OUT_ADMIN_PANEL = 'Выйти из админ-панели';
